import React, { FC, useEffect } from 'react';
import { Switch } from 'antd';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { P } from '../components/font/Parargraph';
import { Text } from '../components/font/Text';
import Spacer from '../components/layout/Spacer';
import Loading from '../components/loading/Loading';
import { useToast } from '../components/toast/ToastProvider';
import BodyShapes from '../components/widget/BodyShapes';
import CmToInches from '../components/widget/CmToInches';
import Cta from '../components/widget/Cta';
import WidgetBackground from '../components/widget/WidgetBackground';
import WidgetFonts from '../components/widget/WidgetFonts';
import {
  changeEasysizeWatermarkDisplayStatus,
  getWidgetFeatures,
  resetWidgetStatus,
  setWidgetFeatures,
} from '../reducers/fit.quiz.widget.reducer';

import { useAppSelector, useAppDispatch } from '../redux/redux.hooks';
import { generateWidgetFeature } from '../utils/widget.features.helper';

type WidgetProps = {};

const Widget: FC<WidgetProps> = () => {
  const params = useParams();
  const { id } = params;
  const dispatch = useAppDispatch();
  const { data, status, getStatus } = useAppSelector(
    (state) => state.widgetReducer
  );
  const toast = useToast();
  // const [showEsWatermark, setShowEsWatermark] = useState<boolean>(true);

  const handleCustomizeWidget = () => {
    const feature = generateWidgetFeature(data, id!);
    dispatch(setWidgetFeatures(feature));
  };

  useEffect(() => {
    dispatch(getWidgetFeatures(id!));
  }, [dispatch, id]);

  useEffect(() => {
    if (status === 'error') {
      toast.show('Failed to update the widget 😿', { isError: true });
      dispatch(resetWidgetStatus());
    } else if (status === 'successful') {
      toast.show('Widget updated successfully 🕺');
      dispatch(resetWidgetStatus());
    }
  }, [dispatch, status, toast]);

  const renderView = () => {
    if (getStatus === 'loading') {
      return <Loading loadingMessage='Fetching widget features' />;
    }
    return (
      <Container>
        <SwitchContainer>
          <Switch
            checked={data.showEasysizeWatermark}
            style={{
              backgroundColor: data.showEasysizeWatermark
                ? '#008060'
                : '#ccc',
              alignSelf: 'flex-end',
            }}
            onChange={() =>
              dispatch(
                changeEasysizeWatermarkDisplayStatus(
                  !data.showEasysizeWatermark
                )
              )
            }
          />
          &nbsp;
          <Text>Show "Powered by Easysize"</Text>
        </SwitchContainer>
        <Spacer height={24} />
        <CmToInches />
        <Spacer height={24} />
        <Cta />
        <Spacer height={24} />
        <WidgetBackground />
        <Spacer height={24} />
        <WidgetFonts />
        <Spacer height={24} />
        <BodyShapes />
        <CustomizeWidget onClick={handleCustomizeWidget}>
          {status === 'loading' ? (
            <s-spinner accessibilityLabel='Updating widget' />
          ) : (
            <P>Customize widget</P>
          )}
        </CustomizeWidget>
      </Container>
    );
  };

  return <>{renderView()}</>;
};

export default Widget;

const Container = styled.div`
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 80px;
`;

const CustomizeWidget = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  padding-top: 12px;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 36px;
  bottom: 48px;
  right: 48px;
  color: #315f46;
  background-color: white;
  text-align: center;
  box-shadow: 4px 4px 10px #939794cc;
  cursor: pointer;
`;

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;
